<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'VIEWS'" [breadcrumb]="''" [count]="count" icon="fa-cog">
</app-breadcrumb>
<div class="content-background">
  <div class="row">
    <div class="col-sm-12">
      <div class="inputWithIcon inputWithIcon-search float-right d-flex">
        <app-advanced-mode id="viewGridAdvancedSwitch" [storageKey]="'view-list'"
          (collapsibleToggle)="enableAdvanced=$event">
        </app-advanced-mode>
        <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
          (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
        <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <kendo-grid [data]="view.gridData" [loading]="view.loading" [navigable]="true"
      [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
      [pageSize]="view.state.take" [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort"
      [filterable]="enableAdvanced" [filter]="view.state.filter" [groupable]="enableAdvanced" [group]="view.groups"
      [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
      (groupChange)="groupChange($event)" (dataStateChange)="dataStateChange($event)">
      <kendo-grid-messages noRecords="{{ 'NO-VIEWS' | translate }}">
      </kendo-grid-messages>
      <kendo-grid-column field="name" [width]="20" title="{{ 'NAME' | translate }}"></kendo-grid-column>
      <kendo-grid-column field="viewName" [width]="30" title="{{ 'VIEW-NAME' | translate }}"></kendo-grid-column>
      <kendo-grid-column field="viewType" title="{{ 'VIEW-TYPE' | translate }}" [width]="10" [columnMenu]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.viewType === 'REPORT' ? reportText : metricText}}
        </ng-template>
        <ng-template kendoGridFilterCellTemplate let-filter>
          <app-dropdown-filter [filter]="filter" [data]="viewTypes" filterField="viewType"
            selectDefaultText="{{ 'SELECT-TYPE' | translate }}" textField="name" valueField="value">
          </app-dropdown-filter>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="authorizedRolesText" title="{{ 'AUTHORIZED-ROLES' | translate }}" [width]="17"
        class="ellipsis-text">
      </kendo-grid-column>
      <kendo-grid-column field="lastModifiedBy" [width]="15" title="{{ 'LAST-MODIFIED-BY' | translate }}">
      </kendo-grid-column>
      <kendo-grid-column field="lastModifiedOn" [width]="15" title="{{ 'LAST-MODIFIED-DATE' | translate }}"
        filter="date" format="{0:g}"></kendo-grid-column>
      <kendo-grid-command-column [width]="10" title="{{ 'ACTIONS' | translate }}" class="text-center">
        <ng-template kendoGridCellTemplate let-dataItem>
          <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem['id'])">
          </i>
          &nbsp;
          <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
            (click)="deleteHandler(dataItem['id'], dataItem['viewName'])">
          </i>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
    <button kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3" (click)="addHandler()">
      {{'ADD' | translate}}<i class="far fa-plus"></i>
    </button>
  </div>
</div>

<!--Add/Edit form-->
<app-view-edit [isNew]="isNew" [model]="editDataItem" (save)="saveChangesHandler($event)"
  (cancelling)="cancelChangesHandler()">
</app-view-edit>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
  [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-VIEW-DELETION' | translate }}</p>
  <span class="k-font-weight-bold">{{selectedView.name}}</span>
  <kendo-dialog-actions>
    <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate
      }}</button>
  </kendo-dialog-actions>
</kendo-dialog>